import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { IAgencyNumberConfigResponse } from '../store/configurations.types'
import { ConfigurationsService } from '../services/configurations.service'
import * as actions from '../store/configurations.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setAgencyNumberConfig() {
  const serviceId: string = yield select(getServiceIdSelector)
  const configurationsService = new ConfigurationsService(serviceId)
  try {
    const response: IAgencyNumberConfigResponse = yield call([
      configurationsService,
      configurationsService.getAgencyNumberDoc,
    ])
    const { entity } = response
    if (entity && entity.length) {
      yield put(actions.setAgencyNumberConfig(entity))
    }
  } catch (e) {
    yield put(throwPcrException(`setAgencyNumberConfig() error: ${e}`))
  }
}

export function* setAgencyNumberConfigSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setAgencyNumberConfig)
}
